import React, { FC } from 'react';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useDeleteApplicationMutation } from 'core/api/applications';
import { ModalType } from 'core/useCases/modal/types';
import { useModalStore } from 'stores/modal';
import DeleteIcon from 'images/icons/Delete.svg?react';
import DeleteDisableIcon from 'images/icons/DeleteDisable.svg?react';
import Application from 'core/models/application';

type DeleteApplicationButtonProps = {
    application: Application;
    postAction?: () => void;
};

const DeleteApplicationButton: FC<DeleteApplicationButtonProps> = ({ application, postAction }) => {
    const { t } = useTranslation();
    const openModal = useModalStore((s) => s.openModal);
    const { mutateAsync: deleteApplication } = useDeleteApplicationMutation();

    const openConfirmationModal = () => {
        openModal({
            confirmAction: async () => {
                try {
                    await deleteApplication(application.id);

                    if (postAction) {
                        postAction();
                    }

                    toast.success(t('application.delete.success'));
                } catch (e) {
                    toast.error(t('common.error-occured'));
                }
            },
            defaultValues: application,
            title: t('application.ask-to-delete-application'),
            type: ModalType.Confirmation,
        });
    };

    return application.isDeletable ? (
        <button onClick={openConfirmationModal} title={t('common.delete')} type="button">
            <DeleteIcon />
        </button>
    ) : (
        <button title={t('application.delete-disabled')} type="button" disabled>
            <DeleteDisableIcon />
        </button>
    );
};

export default DeleteApplicationButton;
